import eventsApi from "@/services/api.event.service";
import { ActionContext, ActionTree } from "vuex";
import { RootState } from "../types";
import { EventLinksState } from "./types";
import { PaginatedSearchRequest } from "@/mixins/PaginatedSearch";

export const actions: ActionTree<EventLinksState, RootState> = {
	async fetchEventLinksTable({ commit }: ActionContext<EventLinksState, RootState>, request: PaginatedSearchRequest): Promise<void> {
		try {
			const eventLinks = await eventsApi.retrieveEventLinks(request);
			commit("setEventLinksTable", eventLinks);
		}
		catch (error) {
			commit("setEventLinksTable", {
				eventLinks: {
					eventLinks: {
						data: [],
						pageNumber: 1,
						pageSize: 0,
						totalRecords: 0,
					},
					noPermissionCount: 0
				}
			});
			console.error("Failed to retrieve event links for table view: ", error);
		}
	},

	async fetchEventLinksList({ commit }: ActionContext<EventLinksState, RootState>, request: PaginatedSearchRequest): Promise<void> {
		try {
			const eventLinks = await eventsApi.retrieveEventLinks(request);
			commit("setEventLinksList", eventLinks);
		}
		catch (error) {
			commit("setEventLinksList", {
				eventLinks: {
					eventLinks: {
						data: [],
						pageNumber: 1,
						pageSize: 0,
						totalRecords: 0,
					},
					noPermissionCount: 0
				}
			});
			console.error("Failed to retrieve event links for list view: ", error);
		}
	}
};
